// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'fx-currency.page.title': 'Currencies',
    'fx-currency.page.archive.title': 'Archived Currencies',
    'fx-currency.page.search_results': 'Search Results',
    'fx-currency.page.create.title': 'Create New Currency',
    'fx-currency.page.search.title': 'Find Currencies',
    'fx-currency.page.edit.title': 'Edit Currency',
    'fx-currency.page.view.title': 'View Currency',
    'fx-currency.page.all': 'All',

    'fx-currency.button.cancel': 'Cancel',
    'fx-currency.button.select': 'Select',
    'fx-currency.button.find': 'Find Currencies',
    'fx-currency.button.search': 'Apply',
    'fx-currency.button.create': 'Save Currency',
    'fx-currency.button.new': 'Add Currency',
    'fx-currency.button.save': 'Save Changes',
    'fx-currency.button.archive': 'Archive',
    'fx-currency.button.delete': 'Permanently Delete',
    'fx-currency.button.edit': 'Edit',
    'fx-currency.button.restore': 'Restore',
    'fx-currency.button.reset': 'Reset',

    'fx-currency.placeholder.search': 'Search fx currencies',

    'fx-currency.link.create_first_fx_currency': 'Click here to create your first fx currency',
    'fx-currency.link.fx_currencies': ' Return to Currencies',
    'fx-currency.link.archive': 'Archived Currencies',
    'fx-currency.link.retry': 'Click here to retry',

    'fx-currency.checkbox.all': 'Check All',
    'fx-currency.checkbox.actions_label': 'with selected',

    'fx-currency.label.currency_name': 'Currency',

    'fx-currency.sort.field_label': 'Field',
    'fx-currency.sort.direction_label': 'Direction',
    'fx-currency.sort.direction_ascending': 'Ascending',
    'fx-currency.sort.direction_descending': 'Descending',

    'fx-currency.modal.title.fx_currency_archive': 'Archive Currency',
    'fx-currency.modal.title.fx_currency_delete_permanently': 'Delete Currency',
    'fx-currency.modal.title.fx_currency_restore': 'Restore Currency',

    'fx-currency.modal.message.fx_currency_archive': 'Are you sure that you want to move this fx currency to the archive? | Are you sure that you want to move these fx currencies to the archive?',
    'fx-currency.modal.message.fx_currency_delete_permanently':
        'Are you sure that you want to permanently delete this fx currency? This action cannot be undone. | Are you sure that you want to permanently delete these fx currencies? This action cannot be undone.',
    'fx-currency.modal.message.fx_currency_restore': 'Are you sure that you want to restore this fx currency? | Are you sure that you want to restore these fx currencies?',

    'fx-currency.success.message.fx_currency_created': 'Your fx currency has been created',
    'fx-currency.success.message.fx_currency_updated': 'Your fx currency has been updated',
    'fx-currency.success.message.fx_currency_restored': 'Your fx currency has been restored | All selected fx currencies were restored',
    'fx-currency.success.message.fx_currency_deleted': 'Your fx currency has been permanently deleted | All selected fx currencies were permanently deleted',
    'fx-currency.success.message.archived_fx_currencies': 'Your fx currency was moved to the archive | All selected fx currencies were moved to the archive',

    'fx-currency.error.message.archived_fx_currencies': 'This fx currency was already moved to the archive | These fx currencies were already moved to the archive',
    'fx-currency.error.message.fx_currency_deleted': 'This fx currency was already permanently deleted | These fx currencies were already permanently deleted',
    'fx-currency.error.message.fx_currency_restored': 'This fx currency was already restored | These fx currencies were already restored',
    'fx-currency.error.message.error_loading_page': 'Sorry, there was an error loading fx currency.| Sorry, there was an error loading fx currencies.',

    'fx-currency.message.search.no_archived_fx_currencies': "You haven't archived any fx any currencies as yet.",
};
